import { MailService } from './mail-service/mail.service';
import { environment } from '../../environments/environment';

const getApiUrl = (): string => {
  return environment.apiUrl;
};

// Export the MailService and any other services you want to include
export {
  MailService,
  getApiUrl,
 };
